import React from 'react';
import AuthCheck from '../components/auth-check.js';
import SettingsTeamPermissions from '../components/customers/settings-team-attendant.js';
import MountAtPageTop from '../components/utility/mount-at-page-top.js';
import setTitle from '../decorators/set-title.js';
import NavBarAttendant from '../components/nav/navbar-attendant.js';

export class SettingsTeamAttendantRoute extends React.PureComponent {
  render() {
    return (
      <div>
        <AuthCheck permissions={{ can_manage_employees_locations: true }} />
        <NavBarAttendant />
        <MountAtPageTop />
        <div className="variable-width-column">
          <div className="settings-panel" style={{ maxWidth: '50rem' }}>
            <SettingsTeamPermissions />
          </div>
        </div>
      </div>
    );
  }
}

SettingsTeamAttendantRoute = setTitle((props) => {
  return 'Team Permissions';
})(SettingsTeamAttendantRoute);

export default SettingsTeamAttendantRoute;
